<template>
  <div>
    <ControlPanel :title="'Раздел: Отчёты для КНП'" :icon="'mdi mdi-folder'" :links="links">
    </ControlPanel>
    <div class="container-fluid">
      <Category>
        <template v-slot:pos1>
          <p>Формы налоговой отчетности для Кабинета налогоплательщика в формате JSON для загрузки в <a href="https://knp.kgd.gov.kz/" target="_blank">https://knp.kgd.gov.kz/</a>. </p>
        </template>
        <template v-slot:pos2>
          <table class="table table-sm table-bordered">
            <tr>
              <td><b-link to="/fno/200.00/">Регламентированный отчёт: форма 200.00</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/fno/910.00/">Регламентированный отчёт: форма 910.00</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/fno/920.00/">Регламентированный отчёт: форма 920.00</b-link></td>
            </tr>
          </table>
        </template>
      </Category>
    </div>
  </div>
</template>


<script>
import Category from "@/components/base/Category.vue";
import ControlPanel from "@/components/base/ControlPanel.vue";
import {mapGetters} from "vuex";

export default {
  name: 'FnoDefault',
  components: {
    ControlPanel,
    Category
  },
  data: function () {
    return {

    }
  },
  computed:  {
    ...mapGetters({
      links: 'links'
    })
  },
}
</script>